// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { number, string, boolean } from "@altostra/type-validations/lib/primitives";

const contentBlockValidationObject = objectOf({
  id: string,
  name: string,
  included_count: number,
  created: objectOf({
    time: number,
    name: string,
    d_id: string,
    api_key_name: string,
  }),
  last_edited: objectOf({
    time: number,
    name: string,
    d_id: string,
    api_key_name: string,
  }),
  content_type: string,
  api_identifier: string,
  description: maybe(string, true),
  is_draft: boolean,
  marked_as_deleted: boolean,
  tag_names: maybe(arrayOf(string), true),
  territory_ids: maybe(arrayOf(string), true),
  is_dnd_template: boolean,
});

export const isEngagementContentBlocksResult = objectOf({
  hits: number,
  results: arrayOf(contentBlockValidationObject),
});
